var map = {
	"./Logo Glomed.png": "1U8g",
	"./Logo MoviWearMed.png": "Ndjq",
	"./Logo_Foxi.png": "yk50",
	"./Logo_FoxiMed.png": "54pb",
	"./adjust.png": "xVpr",
	"./adjust1.png": "urJ1",
	"./back.jpg": "QloY",
	"./blood-pressure-gauge.svg": "kJmm",
	"./ecg_process.gif": "890A",
	"./heart-monitor.svg": "UNTM",
	"./logo.png": "iQH9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 7